import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { BookOpen, Waves, Users, ClipboardList } from "lucide-react";
import { AreaLayout } from "@/components/AreaLayout";

const CARDS = [
  { to: "/academia", icon: BookOpen, t: "Continúa el método", d: "Recorre Da el Paso, paso a paso.", cta: "Continuar método" },
  { to: "/medita", icon: Waves, t: "Medita", d: "Baja el ruido antes de decidir.", cta: "Ver práctica" },
  { to: "/comunidad", icon: Users, t: "Comparte tu avance", d: "No tienes que recorrerlo sola.", cta: "Entrar" },
  { to: "/seguimiento", icon: ClipboardList, t: "Prepara tu seguimiento", d: "Llega a tu sesión sabiendo qué trabajar.", cta: "Preparar" },
];

export default function Area() {
  return (
    <AreaLayout>
      <p className="eyebrow mb-4">Mi espacio</p>
      <h1 className="font-display text-4xl text-[#102B5B] sm:text-5xl" style={{ fontWeight: 600 }} data-testid="area-title">
        Tu espacio para seguir avanzando.
      </h1>
      <p className="mt-4 max-w-2xl text-lg text-[#343A46]">
        Esta versión muestra la arquitectura inicial. Algunas funciones que necesitan cuenta
        completa aparecen como «Próximamente».
      </p>
      <div className="mt-10 grid gap-6 sm:grid-cols-2">
        {CARDS.map((c, i) => (
          <motion.div
            key={c.to}
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.35, delay: i * 0.08 }}
          >
            <Link to={c.to} data-testid={`area-card-${i}`} className="soft-card group block p-7 transition-transform duration-150 hover:-translate-y-1">
              <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-[#E6EEFA] text-[#275FBE]">
                <c.icon size={24} />
              </span>
              <h2 className="mt-5 text-xl font-semibold text-[#171A20]">{c.t}</h2>
              <p className="mt-2 text-base text-[#626B79]">{c.d}</p>
              <span className="mt-4 inline-block text-base font-semibold text-[#1F4C98] group-hover:underline">
                {c.cta} →
              </span>
            </Link>
          </motion.div>
        ))}
      </div>
    </AreaLayout>
  );
}
